import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { HintDesktop as Hint } from '@alfa-bank/site-hint/desktop';
import { Input as CoreInput } from '@alfalab/core-components-input';

import { Input as Component } from './input';
import type { TInput, IDeps } from './models/models';
import styles from './styles/styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const Input = createWidget<IDeps, TInput>({
    styles,
    CoreInput,
    Hint,
})(Component);
